import { Clock, CheckCircle2, Smartphone, Quote } from "lucide-react";
import { useTranslation } from "@thyra/landing-i18n";
import { SectionHeader } from "./ui/SectionHeader";

const STATS = [
  { id: "setup", Icon: Clock },
  { id: "coverage", Icon: CheckCircle2 },
  { id: "price", Icon: Smartphone },
] as const;

const SCENARIOS = ["inbox", "calendar", "research"] as const;

export function OutcomesSection() {
  const { t } = useTranslation("home");

  return (
    <section className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow={t("outcomes.eyebrow")}
          title={t("outcomes.title")}
          description={t("outcomes.description")}
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {STATS.map(({ id, Icon }, i) => (
            <div
              key={id}
              data-aos="fade-up"
              data-aos-delay={i * 90}
              className="marketing-card marketing-card-hover flex flex-col items-center px-6 py-8 text-center"
            >
              <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
                <Icon className="h-5 w-5 text-primary" aria-hidden />
              </span>
              <p className="heading-gradient text-3xl font-semibold tracking-tight">
                {t(`outcomes.stats.${id}.value`)}
              </p>
              <p className="mt-1 text-sm text-muted-foreground">
                {t(`outcomes.stats.${id}.label`)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {SCENARIOS.map((id, i) => (
            <figure
              key={id}
              data-aos="fade-up"
              data-aos-delay={i * 90}
              className="marketing-card marketing-card-hover relative p-6"
            >
              <Quote
                className="h-5 w-5 text-primary/30"
                aria-hidden
                strokeWidth={2}
              />
              <blockquote className="mt-3 text-sm leading-relaxed text-card-foreground">
                {t(`outcomes.scenarios.${id}.quote`)}
              </blockquote>
              <figcaption className="mt-4 inline-flex rounded-full bg-primary/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-primary">
                {t(`outcomes.scenarios.${id}.context`)}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
